import {ActivatedRoute, Params} from '@angular/router';
import {ChartsSearchInterface} from '../models/charts-search.interface';
import {FormGroup} from '@angular/forms';


export const buildQueryParams = (search: ChartsSearchInterface): Params => {
  const queryParams = {};

  if (search.displayUnits) {
    Object.assign(queryParams, {displayUnits: search.displayUnits});
  }
  if (search.categoryType && search.categoryType !== '') {
    Object.assign(queryParams, {categoryType: search.categoryType});
  } else {
    Object.assign(queryParams, {categoryType: 'NEW'});
  }
  if (search.startYear) {
    Object.assign(queryParams, {startYear: search.startYear});
  }
  if (search.years && search.years.length > 0) {
    Object.assign(queryParams, {years: search.years});
  }
  if (search.categories && search.categories.length > 0) {
    Object.assign(queryParams, {categories: search.categories});
  }
  if (search.types && search.types.length > 0) {
    Object.assign(queryParams, {types: search.types});
  }
  if (search.detailLevel && search.detailLevel !== '') {
    Object.assign(queryParams, {detailLevel: search.detailLevel});
  }
  if (search.b2bB2c && search.b2bB2c !== '') {
    Object.assign(queryParams, {b2bB2c: search.b2bB2c});
  }
  if (search.member && search.member !== '') {
    Object.assign(queryParams, {member: search.member});
  }
  if (search.region && search.region !== '') {
    Object.assign(queryParams, {region: search.region});
  }
  if (search.type && search.type !== '') {
    Object.assign(queryParams, {type: search.type});
  }
  if (search.countries && search.countries.length > 0) {
    Object.assign(queryParams, {countries: search.countries});
  }
  if (search.order && search.order !== '') {
    Object.assign(queryParams, {order: search.order});
  }
  if (search.costCategories && search.costCategories.length > 0) {
    Object.assign(queryParams, {costCategories: search.costCategories});
  }
  if (search.countries && search.countries.length > 0) {
    Object.assign(queryParams, {countries: search.countries});
  }
  return queryParams;
};

export const getFiltersFromQueryParams = (params: Params): ChartsSearchInterface => {
  const search = {} as ChartsSearchInterface;

  if (params.displayUnits) {
    search.displayUnits = params.displayUnits;
  }
  if (params.categoryType) {
    search.categoryType = params.categoryType;
  }
  if (params.startYear) {
    search.startYear = params.startYear;
  }
  if (params.years) {
    search.years = params.years;
  }
  if (params.categories) {
    if (Array.isArray(params.categories)) {
      search.categories = params.categories;
    } else  {
      search.categories = [params.categories];
    }
  }
  if (params.detailLevel) {
    search.detailLevel = params.detailLevel;
  }
  if (params.b2bB2c) {
    search.b2bB2c = params.b2bB2c;
  }
  if (params.region) {
    search.region = params.region;
  }
  if (params.type) {
    search.type = params.type;
  }
  if (params.member) {
    search.member = params.member;
  }
  if (params.countries) {
    search.countries = params.countries;
  }
  if (params.type) {
    search.type = params.type;
  }
  if (params.order) {
    search.order = params.order;
  }

  if (params.costCategories) {
    if (Array.isArray(params.costCategories)) {
      search.costCategories = params.costCategories;
    } else  {
      search.costCategories = [params.costCategories];
    }
  }
  if (params.countries) {
    search.countries = params.countries;
  }

  return search;
};

export const setFormValuesFromQueryParams = (searchForm: FormGroup, activatedRouter: ActivatedRoute): void => {
  activatedRouter.queryParams.subscribe((params) => {
    if (params.displayUnits) {
      searchForm.get('displayUnits')?.setValue(params.displayUnits);
    }
    if (params.categoryType) {
      searchForm.get('categoryType')?.setValue(params.categoryType);
    }
    if (params.startYear) {
      const year: number = +params.startYear;
      searchForm.get('startYear')?.setValue(year);
      searchForm.get('year')?.setValue(year);
    }
    if (params.categories) {
      if (Array.isArray(params.categories)) {
        searchForm.get('categories')?.setValue(params.categories);
      } else {
        searchForm.get('categories')?.setValue([params.categories]);
      }
    }
    if (params.categories) {
      if (Array.isArray(params.categories)) {
        searchForm.get('collectionStreams')?.setValue(params.categories);
      } else {
        searchForm.get('collectionStreams')?.setValue([params.categories]);
      }
    }
    if (params.detailLevel) {
      searchForm.get('detailLevel')?.setValue(params.detailLevel);
    }
    if (params.b2bB2c) {
      searchForm.get('b2bB2c')?.setValue(params.b2bB2c);
    }
    if (params.member) {
      searchForm.get('member')?.setValue(params.member);
    }
    if (params.region) {
      searchForm.get('region')?.setValue(params.region);
    }
    if (params.countries) {
      const countries: number = +params.countries;
      searchForm.get('countries')?.setValue(countries);
    }
    if (params.order) {
      searchForm.get('order')?.setValue(params.order);
    }
    if (params.costCategories) {
     
      if (Array.isArray(params.costCategories)) {
        searchForm.get('costCategories')?.setValue(params.costCategories);
      } else {
        searchForm.get('costCategories')?.setValue([params.costCategories]);
      }
    }
    if (params.types) {
      if (Array.isArray(params.types)) {
        searchForm.get('types')?.setValue(params.types);
      } else {
        searchForm.get('types')?.setValue([params.types]);
      }
    }
  });
};

